let Rejected = function() {	
	return this.InvoicesList.filter((r) => r.status === 3);
};
export default Rejected;
